<template>
  <div>
    <modal
      v-if="isOpen"
      cancel-text="Cerrar"
      icon="fa-search"
      :show="true"
      :show-save="false"
      show-top-close
      title="Detalle de Visitas"
      width="50%"
      @cancel="$emit('onClose')"
    >
      <div
        v-for="(item, idx) in itemsPaginated"
        :key="`${item.visitTypeName}${idx}`"
        class="row mb-2 bg-secondary-3 mx-4"
      >
        <div
          class="col-12"
          :class="showReason(item.visitTypeId) ? 'col-md-6' : 'col-md-12'"
        >
          <span class="data-label">Tipo:</span>
          <p class="data">{{ infoDisplay(item).visitTypeName }}</p>
        </div>
        <div v-if="showReason(item.visitTypeId)" class="col-6">
          <span class="data-label">Razón:</span>
          <p class="data">{{ infoDisplay(item).justification }}</p>
        </div>
        <div class="col-12 col-md-6">
          <span class="data-label">Fecha:</span>
          <p class="data">{{ item.visitDateFormat }}</p>
        </div>
        <div class="col-12 col-md-6">
          <span class="data-label">Horario:</span>
          <p class="data" v-html="setBoldMinutes(item.completeTime)" />
        </div>
      </div>

      <pagination
        v-if="items.length > count"
        :data="pagination"
        @pagination-go-page="currentPage = $event"
      />

      <result-not-found v-if="items.length == 0" />
    </modal>
  </div>
</template>

<script>
import Modal from '@/shared/components/CustomModal';
import { getVisitHistory as _getVisitHistory } from '@/modules/shared/studentreferral.api';
import Pagination from '@/components/common/Pagination';
import ResultNotFound from '@/components/common/ResultNotFound';
import visitTypes from '@/utils/constants/visitTypes.js';

export default {
  name: 'VisitDetailsHistory',
  components: {
    Modal,
    Pagination,
    ResultNotFound,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: () => false,
    },
    admissionId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      items: [],
      currentPage: 1,
      count: 15,
    };
  },
  computed: {
    showReason() {
      return (visitTypeId) => {
        return (
          visitTypeId == visitTypes.Ausencia || visitTypeId == visitTypes.UnSet
        );
      };
    },
    infoDisplay() {
      return (item) => {
        return {
          visitTypeName:
            item.absenceId != 0 ? 'Ausencia de Admisión' : item.visitTypeName,
          justification:
            item.justification || item.reasonOther || item.reason?.name,
        };
      };
    },
    pagination() {
      return {
        currentPage: this.currentPage,
        count: this.count,
        totalItemCount: (this.items || []).length,
        pageCount: Math.ceil((this.items || []).length / this.count),
      };
    },
    itemsPaginated() {
      let since = (this.pagination.currentPage - 1) * this.pagination.count;
      let until = since + this.pagination.count;
      return this.items.slice(since, until);
    },
  },
  watch: {
    isOpen(value) {
      if (value) {
        _getVisitHistory(this.admissionId).then(({ data }) => {
          this.items = data;
        });
      }
    },
  },
  methods: {
    setBoldMinutes(str) {
      let date = str.substring(0, str.indexOf('('));
      let minutes = str.substring(str.indexOf('('), str.length);
      return `${date} <span class="font-weight-bold">${minutes}</span>`;
    },
  },
};
</script>
